import { BooleanValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
import { facetIdDefinition } from '../facets/generic/facet-actions-validation.js';
export const updateFacetOptions = createAction('facetOptions/update', (payload = { freezeFacetOrder: true }) => validatePayload(payload, {
    freezeFacetOrder: new BooleanValue({ required: false }),
}));
export const enableFacet = createAction('facetOptions/facet/enable', (payload) => validatePayload(payload, facetIdDefinition));
export const disableFacet = createAction('facetOptions/facet/disable', (payload) => validatePayload(payload, facetIdDefinition));
